import request from '../../utils/request'
// 奖励详情
const rewardDetail = (data) => {
  return request({
      url: `/mp/fission/reward/detail`,
      method: 'get',
  })
}
// 奖励列表
const rewardList = (data,page) => {
  let str = data == 0 ? '':`?settling=${data}`;
  return request({
      url: `/mp/fission/reward/list/${page}${str}`,
      method: 'get',
  })
}


export {
    rewardDetail,
    rewardList
}